import { render, staticRenderFns } from "./insertFlowNode.vue?vue&type=template&id=4c9b45ca&"
import script from "./insertFlowNode.vue?vue&type=script&lang=js&"
export * from "./insertFlowNode.vue?vue&type=script&lang=js&"
import style0 from "./insertFlowNode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports